import React, { useState } from "react";

const SymptomSelector = ({ label, categories, selected, setSelected }) => {
  const [addingCustom, setAddingCustom] = useState(false);
  const [customSymptom, setCustomSymptom] = useState("");

  const selectedSymptom = selected;

  return (
    <div>
      <div className="tw-mb-6">
        <div className="tw-flex tw-justify-between tw-mb-3">
          <label className="tw-block">{label}</label>
        </div>

        <>
          <div className="tw-relative tw-mb-2">
            <select
              onChange={(e) => {
                const selected = e.target.value;
                if (selected && selected !== selectedSymptom) {
                  setSelected(selected);
                }
              }}
              className="tw-w-full tw-border tw-rounded-lg tw-p-4 dark:tw-bg-black"
              style={{
                WebkitAppearance: "none",
                MozAppearance: "none",
                appearance: "none",
              }}
              value={selectedSymptom}
            >
              <option value="">Select symptom</option>
              {Array.isArray(categories) &&
                categories.map((symptom) => (
                  <option key={symptom} value={symptom}>
                    {symptom}
                  </option>
                ))}
            </select>
            <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-1 tw-flex tw-items-center tw-pr-4">
              <svg
                className="tw-w-4 tw-h-4 tw-text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>

          {addingCustom && (
            <input
              type="text"
              className="tw-mt-3 tw-border tw-rounded-full tw-p-4 tw-w-full"
              placeholder="Enter custom symptom and press Enter"
              value={customSymptom}
              onChange={(e) => setCustomSymptom(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && customSymptom.trim()) {
                  e.preventDefault();
                  const normalized = customSymptom.trim();
                  const capitalized =
                    normalized.charAt(0).toUpperCase() + normalized.slice(1);
                  if (capitalized !== selectedSymptom) {
                    setSelected(capitalized);
                  }
                  setCustomSymptom("");
                  setAddingCustom(false);
                }
              }}
            />
          )}
        </>
      </div>
    </div>
  );
};

export default SymptomSelector;
